import { Injectable } from "@angular/core";
import { RxApiService } from "../../../core/communication/http/rx-api.service";
import { Observable } from "rxjs";
import { ApiResponseResultBundle, ApplicationRequest, ListResponseData } from "../../../core/types";

@Injectable({
    providedIn: "root"
})
export class ApplicationRequestsService {
    constructor(private api: RxApiService) {}

    public listRequests(appId: string, qs?: Object): Observable<ListResponseData<any>> {
        return this.api.get(["apps", appId, "requests"], qs);
    }

    public getRequest(appId: string, requestId: string): Observable<ApiResponseResultBundle> {
        return this.api.get(["apps", appId, "requests", requestId]);
    }

    public createRequest(appId: string, data: any): Observable<ApplicationRequest> {
        return this.api.post(["apps", appId, "requests"], null, data);
    }

    public updateRequest(appId: string, requestId: string, data: any): Observable<any> {
        return this.api.patch(["apps", appId, "requests", requestId], null, data);
    }

    public removeRequest(appId: string, requestId: string): Observable<any> {
        return this.api.remove(["apps", appId, "requests", requestId]);
    }

    public removeRequestsBulk(appId: string, requestsIds: string[]): Observable<any> {
        return this.api.post(["apps", appId, "requests", "_bulk", "remove"], null, requestsIds);
    }

    public toggleVote(appId: string, requestId: string): Observable<any> {
        return this.api.post(["apps", appId, "requests", requestId, "votes"]);
    }

    public addComment(appId: string, requestId: string, data: any): Observable<any> {
        return this.api.post(["apps", appId, "requests", requestId, "comments"], null, data);
    }

    public listComments(
        appId: string,
        requestId: string,
        qs: any
    ): Observable<ListResponseData<any>> {
        return this.api.get(["apps", appId, "requests", requestId, "comments"], qs);
    }

    public listActivity(
        appId: string,
        requestId: string,
        qs: any
    ): Observable<ListResponseData<any>> {
        return this.api.get(["apps", appId, "requests", requestId, "activity"], qs);
    }
}
